/* eslint-disable import/prefer-default-export */
import DSFilter from './components/DSFilter.react';

export {
    DSFilter
};
